export default {
      id: "icons-large-uzay-usage",
      viewBox: "0 0 21 21",
      url: "/" + "images/icons.3.109.2.svg#icons-large-uzay-usage",
      toString: function () {
        return this.url;
      }
    }